import Container from './Container'

export default {
  Container
}



// WEBPACK FOOTER //
// ./src/personnel/components/index.js